import { useCallback } from 'react';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { FORM_STATUS, useFormStatus } from '../../../contexts/form-status-provider';
import { useSingleSubmit } from './use-single-submit';
import { getCurrentStep } from './utils';
export const useSubmitButton = ({ form, id })=>{
    const { hasSteps, stepNumber, isLastStep } = getCurrentStep(form, id);
    const { inProgress: actionsInProgress, actions } = useFieldActions();
    const { formStatus } = useFormStatus();
    const submitForm = useCallback(async ()=>{
        await actions?.submitForm();
    }, [
        actions
    ]);
    const { submitOnce, isSubmitting } = useSingleSubmit(submitForm);
    const isInProgress = actionsInProgress || formStatus === FORM_STATUS.BUSY;
    const showPreviousButton = hasSteps && stepNumber !== 0;
    const showNextButton = hasSteps && !isLastStep;
    const showSubmitButton = !hasSteps || hasSteps && isLastStep;
    const handleSubmitClick = useCallback(async ()=>{
        if (isInProgress) {
            return;
        }
        await submitOnce();
    }, [
        isInProgress,
        submitOnce
    ]);
    return {
        handleSubmitClick,
        isDisabled: isSubmitting,
        isInProgress,
        isSubmitting,
        showPreviousButton,
        showNextButton,
        showSubmitButton,
        hasSteps
    };
};

//# sourceMappingURL=use-submit-button.js.map